import { useState } from 'react';
import { Checkbox, CheckboxChangeEvent } from '@progress/kendo-react-inputs';
import { KWELLO_ICON, KwelloSvgIcon } from '../../icon/KwelloSvgIcon';
import style from './GroupOptions.module.scss';
import GroupRow from './GroupRow';
import GroupItemLabel from './GroupItemLabel';
import { HandleCheckBoxChange } from '../AutoCompleteTreeFilter';
import { FilterValueObject } from 'common/models/filter.model';
import { Tooltip } from 'react-tooltip';
export interface DataItem {
  value: string;
  name: string;
  alias?: string;
  filterType: string;
  items: DataItem[];
  parents?: DataItem[];
}

interface GroupOptionsProps {
  required: boolean;
  selectedFilters: FilterValueObject[];
  selectedGroups: { [key: string]: DataItem[] };
  parents: DataItem[];
  dataItem: DataItem;
  handleCheckBoxChange: (data: HandleCheckBoxChange) => void;
  toolTip?: string;
}

export default function GroupOptions({
  required,
  selectedFilters,
  selectedGroups,
  parents,
  dataItem,
  handleCheckBoxChange,
  toolTip,
}: Readonly<GroupOptionsProps>) {
  const [itemExpanded, setItemExpanded] = useState(false);

  const selected =
    selectedFilters.findIndex((valueItem) => valueItem.value === dataItem.value) > -1;

  const disabled = required && !selected && selectedGroups?.selectedCategories?.length > 0;

  const onClickItem = (e: any) => {
    e.stopPropagation();

    if (e.target.type === 'checkbox') {
      return;
    }

    setItemExpanded(!itemExpanded);
  };

  const onCheckboxChange = (event: CheckboxChangeEvent) => {
    if (event.value && !itemExpanded) {
      setItemExpanded(true);
    }

    handleCheckBoxChange({
      parents: [],
      children: dataItem.items,
      item: dataItem,
      value: event.value,
    });
  };

  return (
    <li
      id={dataItem.value}
      aria-selected={selected}
      style={{ position: 'unset', borderRadius: 10, opacity: disabled ? 0.5 : 1 }}
      onClick={disabled ? (e) => e.stopPropagation() : (e: any) => onClickItem(e)}
    >
      <div className={style['group-cascade-container']}>
        <div
          className={`${style['group-item']} k-list-item`}
          data-tooltip-id="tree-filters-tooltip"
        >
          {!required && <Checkbox checked={selected} onChange={onCheckboxChange} />}
          {required && toolTip && (
            <Tooltip
              style={{ zIndex: 10, maxWidth: 300 }}
              id="tree-filters-tooltip"
              place="top-start"
            >
              {toolTip}
            </Tooltip>
          )}
          <GroupItemLabel name={dataItem.name ?? ''} alias={dataItem.alias} />
          <div className={style.chevron}>
            <KwelloSvgIcon
              icon={itemExpanded ? KWELLO_ICON.CHEVRON_UP_ICON : KWELLO_ICON.CHEVRON_DOWN_ICON}
            />
          </div>
        </div>

        {!disabled &&
          itemExpanded &&
          dataItem.items?.map((item, index) => (
            <GroupRow
              required={required}
              selectedFilters={selectedFilters}
              key={`${item.value}-${index}`}
              item={item}
              parents={[...parents, dataItem]}
              handleCheckBoxChange={handleCheckBoxChange}
              selectedGroups={selectedGroups}
            />
          ))}
      </div>
    </li>
  );
}
